import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordsPuzzleGameSelectorComponent } from './words-puzzle-game-selector/words-puzzle-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { WordsPuzzleGameCoreService } from './words-puzzle-game-core.service';

@NgModule({
  declarations: [WordsPuzzleGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [WordsPuzzleGameCoreService],
  exports: [WordsPuzzleGameSelectorComponent],
})
export class WordsPuzzleGameCoreModule {}
